import { render, staticRenderFns } from "./spTable.vue?vue&type=template&id=4fe218c6&"
import script from "./spTable.vue?vue&type=script&lang=js&"
export * from "./spTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports